<script lang="ts">
	import { setContext } from 'svelte';
	import { Contexts } from '#lib/constants/contexts.js';
	import { createTimeContext } from '#lib/features/time/utils/createTimeContext/createTimeContext.js';

	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();

	setContext(Contexts.Now, createTimeContext());
</script>

{@render children?.()}
